export const ESTIMATED_ITEM_SIZE = 45;
export const CONTAINER_CSS_PROPS = {
  minWidth: '225px',
  maxHeight: '200px',
};
